import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux"
import { actions } from 'store'
import { CreateAssessmentRM } from "models/RM"
import { useContext } from 'react'
import { app } from 'router/routes'
import { statuses } from 'keys'
import { StoreCrud } from 'store/hooks'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { toast } from 'react-toastify'
import { createAssessmentFetch, updateAssessmentStatusFetch, uploadAudioFileFetch } from 'store/middlewares/assessment.crud'
import { AbilityContext } from 'components/Permissions/Can'

const useCreateAssessment = () => {
    const dispatch = useDispatch()
    const ability = useContext(AbilityContext)
    const { testTaker } = useSelector(state => state.testTaker)
    const { assessment } = useSelector(state => state.assessment)

    const { mutateAsync: updateAssessmentStatus } = useMutation({
        mutationFn: updateAssessmentStatusFetch
    })

    const { mutateAsync: uploadFile } = useMutation({
        mutationFn: uploadAudioFileFetch,
        mutationKey: "upload-file"
    })

    const queryClient = useQueryClient()

    const navigate = useNavigate()

    const createAssessment = async (values) => {
        if (assessment.id) {
            if (ability.can("manage", "student"))
                navigate(app.dashboard)
            else navigate(app.performAssessments)
            await uploadFile({ id: assessment.id, file: values.file })
            queryClient.invalidateQueries({ queryKey: [qc.assessments] })
            queryClient.invalidateQueries({ queryKey: [qc.dashboard] })
        }
        else {
            let assessment = new CreateAssessmentRM(values, testTaker)
            try {
                let nAssessment = await createAssessmentFetch(assessment)
                dispatch(actions.setSnackbars({ type: toast.createAssessment, open: true }))
                updateAssessmentStatus(statuses.uploading, null, nAssessment.id)
                await uploadFile({ id: nAssessment.id, file: values.file })
                await updateAssessmentStatus(statuses.uploaded, null, nAssessment.id)
                queryClient.invalidateQueries({ queryKey: [qc.assessments] })
            }
            catch {
                console.log("error createAssessment")
            }
        }
    }

    return createAssessment
}

export default useCreateAssessment